import { HFBox, HFButton } from '@hf/designSystem/v1';

const COMPACT_BUTTON_SX = { minHeight: 28, px: 1.25, py: 0.25, fontSize: 12 } as const;

/** A grid's head inside the Custom layout: its title, what it is filtered on, and a toggle for its own toolbar. */
export function PanelHeader({ title, summary, open, onToggle }: { title: string; summary: string; open: boolean; onToggle: () => void }) {
  return (
    <HFBox sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, flexShrink: 0, minWidth: 0 }}>
      <HFBox component="h2" sx={{ m: 0, fontSize: 15, fontWeight: 800, whiteSpace: 'nowrap' }}>
        {title}
      </HFBox>
      <HFBox
        component="span"
        title={summary}
        sx={{ ml: 'auto', minWidth: 0, fontSize: 12, color: 'text.secondary', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {summary}
      </HFBox>
      <HFButton size="small" variant="text" aria-expanded={open} onClick={onToggle} sx={COMPACT_BUTTON_SX}>
        {open ? 'Hide filters' : 'Filters'}
      </HFButton>
    </HFBox>
  );
}
